import { ColGroupDef } from 'ag-grid-community'
import { intl } from '../../../../../../i18n'
import { ProgramManagementRow } from '../../../programManagement'
import { getAggregatedValue } from './aggregation'
import {
  RowValueGetter,
  RIGHT_ALIGN_STYLE,
  progressValueFormatter,
  percentValueFormatter,
} from './common'

// --- Progress group ---

// 並び順はプロジェクト計画の進捗状況グループに合わせる:
// 予定進捗率 → 進捗率 → 総数 → 予定完了 → 完了 → 先行 → 遅延 → 残
export const progressColumns: ColGroupDef<ProgramManagementRow> = {
  headerName: intl.formatMessage({ id: 'programManagement.column.progress' }),
  children: [
    {
      colId: 'progress.scheduledProgressRate',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.scheduledProgressRate',
      }),
      width: 90,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) => {
        const total = getAggregatedValue(params, 'progress', 'total')
        const scheduledCompleted = getAggregatedValue(
          params,
          'progress',
          'scheduledCompleted'
        )
        if (!total || total === 0 || scheduledCompleted == null) return null
        return scheduledCompleted / total
      },
      valueFormatter: percentValueFormatter,
    },
    {
      colId: 'progress.progressRate',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.progressRate',
      }),
      width: 80,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) => {
        const total = getAggregatedValue(params, 'progress', 'total')
        const completed = getAggregatedValue(params, 'progress', 'completed')
        if (!total || total === 0 || completed == null) return null
        return completed / total
      },
      valueFormatter: percentValueFormatter,
    },
    {
      colId: 'progress.total',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.total',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'total'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.scheduledCompleted',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.scheduledCompleted',
      }),
      width: 80,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'scheduledCompleted'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.completed',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.completed',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'completed'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.preceding',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.preceding',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'preceding'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.delayed',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.delayed',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'delayed'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.remaining',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.remaining',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) => {
        const total = getAggregatedValue(params, 'progress', 'total')
        const completed = getAggregatedValue(params, 'progress', 'completed')
        if (total == null || completed == null) return null
        return total - completed
      },
      valueFormatter: progressValueFormatter,
    },
  ],
}
